import { render, staticRenderFns } from "./CoozzyCheckIcon.vue?vue&type=template&id=6953a8ec&scoped=true"
import script from "./CoozzyCheckIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyCheckIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyCheckIcon.vue?vue&type=style&index=0&id=6953a8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953a8ec",
  null
  
)

export default component.exports